export type Surface = { kind: 'store' } | { kind: 'admin' }

export function resolveSurface(location: Pick<Location, 'pathname'>): Surface {
  const path = location.pathname.toLowerCase()
  return path === '/admin' || path.startsWith('/admin/') ? { kind: 'admin' } : { kind: 'store' }
}
